import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Managed board section for selections tab
 */
const ManagedBoardSection = (): React.ReactElement => {
  return (
    <div
      className="rounded-tl-lg rounded-tr-lg bg-gray-150"
      data-testid="managed-board-section-component"
    >
      <AccordionV2
        testId="managed-board"
        className="rounded-tl-lg rounded-tr-lg border border-gray-175 py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Managed Board" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 pt-4">
          <p>
            The selection for this Award goes through a rigorous three-stage
            process.
          </p>

          <p>
            In Stage 1, all listed companies are screened based on publicly
            available information of total shareholder returns, corporate
            governance practices, and corporate governance indices such as the
            Singapore Governance and Transparency Index and MSCI ESG Rating.
          </p>

          <p>
            A shortlist between 20 to 30 companies in each category will be
            developed.
          </p>

          <p>
            In Stage 2, additional inputs on shortlisted Companies are obtained
            through research and discreet inquiries. The Best Managed Board
            committee will visit companies which are further shortlisted to
            confirm the information and obtain more information on their board
            practices and processes.
          </p>

          <p>
            In Stage 3, a panel of judges will interview the boards of the final
            shortlisted candidates and rank them for the awards.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ManagedBoardSection;
